import logo from './logo.svg';
import './App.css';
import { Box } from '@mui/material';
import Home from './components/Home/Home';
import { ThemeProvider, createMuiTheme } from '@mui/material';
import theme from './Styles/Styles';
import { Route, Routes } from 'react-router-dom';
import Ecommerce from './components/Portfolio/Ecommerce/Ecommerce';
import ProjectMenu from './components/Portfolio/ProjectMenu/ProjectMenu';

// const theme = createMuiTheme({
//   typography: {
//     fontFamily: [
//       'Poppins',
//     ].join(','),
//   },
// });

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Home />



      </Box>
    </ThemeProvider>
  );
}

export default App;
